import { render, staticRenderFns } from "./PersistTipoOcorrenciaView.vue?vue&type=template&id=dd9cb7c6&"
import script from "./PersistTipoOcorrenciaView.vue?vue&type=script&lang=ts&"
export * from "./PersistTipoOcorrenciaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports